// extracted by mini-css-extract-plugin
export default {"dashboard":"new_dashboard__VYVES"};